import { render, staticRenderFns } from "./FragmentBox.vue?vue&type=template&id=41d2aeec&scoped=true&"
import script from "./FragmentBox.vue?vue&type=script&lang=js&"
export * from "./FragmentBox.vue?vue&type=script&lang=js&"
import style0 from "./FragmentBox.vue?vue&type=style&index=0&id=41d2aeec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d2aeec",
  null
  
)

export default component.exports